import RatingInfo from "./RatingInfo";

const RatingInfoContainer =(props:any)=>{
    return(
        <RatingInfo isOverAllCondition = {props?.isOverAllCondition} RatingValue={props?.RatingValue}/>
    )
}

export default RatingInfoContainer;